import { buyingPowerCalculatorButtonClicked } from './oz-buying-power-calculator-button.tracker'

export default {
  name: 'oz-buying-power-calculator-button',

  methods: {
    openBuyingPowerCalculator () {
      const { query } = this.$route

      this.$router.push({ name: 'buying-power', query: { ...query, from: 'RP' } })

      buyingPowerCalculatorButtonClicked()
    },
  },
}
